import { Link } from 'react-router-dom'
import { useTheme } from '../../contexts/ThemeContext'

interface LogoProps {
  size?: 'small' | 'normal'
  className?: string
  onClick?: () => void
}

export default function Logo({ size = 'normal', className = '', onClick }: LogoProps) {
  const { theme } = useTheme()
  const logoSize = size === 'small' ? 45 : 50
  const textSize = size === 'small' 
    ? 'text-base sm:text-lg' 
    : 'text-lg sm:text-xl'

  return (
    <Link
      to="/"
      onClick={onClick}
      className={`flex items-center gap-2 sm:gap-3 md:gap-4 hover:opacity-80 transition-all duration-300 group flex-shrink-0 ${className}`}
    >
      <div className="relative flex-shrink-0">
        <img
          src="/images/logo.png"
          alt="SAIGON FC Logo"
          width={logoSize}
          height={logoSize}
          className="object-contain transition-all duration-300"
        />
      </div>
      <div className="flex flex-col leading-tight min-w-0 items-start">
        <span
          className={`font-bold ${theme === 'dark' ? 'text-gold-400' : 'text-gold-500'} transition-all duration-300 whitespace-nowrap ${textSize}`}
        >
          SAIGON FC
        </span>
        <span
          className={`font-semibold transition-all duration-300 whitespace-nowrap text-[10px] sm:text-xs ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}
        >
          Training League
        </span>
      </div>
    </Link>
  )
}

